import { createRouter, createWebHistory } from 'vue-router';
import AboutPage from '../components/AboutPage.vue';
import ContactPage from '../components/ContactPage.vue';
import HomePage from '../components/HomePage.vue';
import ServicesPage from '../components/ServicesPage.vue';
import PrivacyPolicy from '../components/PrivacyPolicy.vue';
import TermsAndConditions from '../components/TermsAndConditions.vue';
import YummablePage from '../components/YummablePage.vue';
import RecipeRedirectPage from '@/components/RecipeRedirectPage.vue'

const routes = [
  { path: '/', component: HomePage },
  { path: '/about', component: AboutPage },
  { path: '/services', component: ServicesPage },
  { path: '/contact', component: ContactPage },
  { path: '/privacy-policy', component: PrivacyPolicy },
  { path: '/terms-and-conditions', component: TermsAndConditions },
  { path: '/yummable', component: YummablePage },
  { path: '/recipe/:id', component: RecipeRedirectPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
